import Popup from "../../../Helpers/Popup/Popup";
import trans from "../../../../utils";
import { Modal } from "react-bootstrap";
import { Formik, Form as FormikForm, FieldArray } from "formik";
import * as Yup from "yup";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import {
  InputSelect,
  TimePickerInput,
} from "../../../Helpers/Input/RefactoredInput";
import { Input } from "../../../Helpers/Input/Input";
import Button from "../../../Helpers/Button/Button";

const dayOptions = [
  { label: trans("Sunday"), value: "sun" },
  { label: trans("Monday"), value: "mon" },
  { label: trans("Tuesday"), value: "tue" },
  { label: trans("Wednesday"), value: "wed" },
  { label: trans("Thursday"), value: "thu" },
  { label: trans("Friday"), value: "fri" },
  { label: trans("Saturday"), value: "sat" },
];

const breakSchema = Yup.object({
  start: Yup.string().required(trans("Break start is required")),
  end: Yup.string().required(trans("Break end is required")),
});

const ShiftSchema = Yup.object({
  name: Yup.string().required(trans("Shift name is required")),
  start: Yup.string().required(trans("Start time is required")),
  end: Yup.string().required(trans("End time is required")),
  days: Yup.array().min(1, trans("Select at least 1 day")),
  breaks: Yup.array().of(breakSchema),
});

const ShiftPopup = ({ openShiftPopup, setOpenShiftPopup, onSave }) => {
  const initialValues = {
    name: "",
    start: "08:00",
    end: "17:00",
    days: [],
    breaks: [],
  };
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    // you can replace this with an API call
    console.log("NEW SHIFT:", values);
    setSubmitting(false);
    resetForm();
    if (onSave) onSave(values); // let parent refresh the list
    setOpenShiftPopup(false);
  };

  return (
    <Popup show={!!openShiftPopup} size={"lg"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={trans("Add New Shift")}
            style=""
            nospace={true}
          />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={() => setOpenShiftPopup(false)}
          img="Close"
        />
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={ShiftSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <>
            <Modal.Body className="modal-body-scrollable">
              <Input
                title={trans("Shift name")}
                type="text"
                placeholder={trans("Ex. Morning")}
                formstyle="form-input"
                id="name"
                name="name"
                value={values.name}
                errors={errors.name}
                touched={touched.name}
                onChange={(e) => setFieldValue("name", e.target.value)}
                onBlur={() => setFieldTouched("name", true)}
              />
              <div className="row">
                <div className="col-lg-6">
                  <TimePickerInput
                    title={trans("Shift start")}
                    id="start"
                    name="start"
                    value={values.start}
                    errors={errors.start}
                    touched={touched.start}
                    onChange={(val) => setFieldValue("start", val)}
                    onBlur={() => setFieldTouched("start", true)}
                  />
                </div>
                <div className="col-lg-6">
                  <TimePickerInput
                    title={trans("Shift end")}
                    id="end"
                    name="end"
                    value={values.end}
                    errors={errors.end}
                    touched={touched.end}
                    onChange={(val) => setFieldValue("end", val)}
                    onBlur={() => setFieldTouched("end", true)}
                    formstyle="form-input select-z-index"
                    defaultTime={"17:00"}
                  />
                </div>
              </div>
              <InputSelect
                id="days"
                name="days"
                label={trans("Working days")}
                placeholder={trans("Select days")}
                mode="multiple"
                options={dayOptions}
                value={values.days}
                onChange={(val) => setFieldValue("days", val)}
                onBlur={() => setFieldTouched("days", true)}
                errors={errors.days}
                touched={touched.days}
                formstyle="form-input select-z-index"
              />
              <FieldArray name="breaks">
                {({ push, remove }) => (
                  <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0">{trans("Breaks")}</h5>
                      <Button
                        type="default"
                        icon={<PlusOutlined />}
                        onClick={() => push({ start: "", end: "" })}
                      >
                        {trans("Add Break")}
                      </Button>
                    </div>

                    {values.breaks.map((brk, idx) => (
                      <div
                        key={idx}
                        className="p-3 mb-3 rounded border position-relative"
                        style={{ background: "#fafafa" }}
                      >
                        {/* <Button
                          className="position-absolute top-0 end-0 m-1"
                          type="text"
                          danger
                          onClick={() => remove(idx)}
                          text="✕"
                        /> */}
                        <Button
                          type="text"
                          icon={<DeleteOutlined />}
                          className={
                            "remove-skill position-absolute top-0 end-0 m-1"
                          }
                          danger
                          onClick={() => remove(idx)}
                        />

                        <div className="row">
                          <div className="col-lg-6">
                            <TimePickerInput
                              title={trans("Break start")}
                              id={`breaks[${idx}].start`}
                              name={`breaks[${idx}].start`}
                              value={brk.start}
                              errors={errors.breaks?.[idx]?.start}
                              touched={touched.breaks?.[idx]?.start}
                              onChange={(val) =>
                                setFieldValue(`breaks[${idx}].start`, val)
                              }
                              onBlur={() =>
                                setFieldTouched(`breaks[${idx}].start`, true)
                              }
                            />
                          </div>
                          <div className="col-lg-6">
                            <TimePickerInput
                              title={trans("Break end")}
                              id={`breaks[${idx}].end`}
                              name={`breaks[${idx}].end`}
                              value={brk.end}
                              errors={errors.breaks?.[idx]?.end}
                              touched={touched.breaks?.[idx]?.end}
                              onChange={(val) =>
                                setFieldValue(`breaks[${idx}].end`, val)
                              }
                              onBlur={() =>
                                setFieldTouched(`breaks[${idx}].end`, true)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </FieldArray>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="default"
                onClick={() => setOpenShiftPopup(false)}
                text={trans("Cancel")}
                defaultTime={"10:00"}
              />
              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                text={trans("Submit")}
                defaultTime={"10:30"}
              />
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Popup>
  );
};

export default ShiftPopup;
